// Suprimir warnings de defaultProps específicos do GeistUI
// Este arquivo deve ser importado no index.js antes de qualquer componente

const originalError = console.error;
const originalWarn = console.warn;

console.error = function(...args) {
  // Suprimir warning específico do GeistUI sobre defaultProps
  if (args[0] && typeof args[0] === 'string' && 
      (args[0].includes('defaultProps will be removed from function components') ||
       args[0].includes('GeistTabs: Support for defaultProps'))) {
    return;
  }
  
  // Manter outros errors
  originalError.apply(console, args);
};

console.warn = function(...args) {
  // Suprimir warning específico do GeistUI sobre defaultProps
  if (args[0] && typeof args[0] === 'string' && 
      (args[0].includes('defaultProps will be removed from function components') ||
       args[0].includes('GeistTabs: Support for defaultProps'))) {
    return;
  }
  
  // Manter outros warnings
  originalWarn.apply(console, args);
};

export default {};